import {Component, OnInit} from '@angular/core';
import {Select, Store} from '@ngxs/store';
import {AppState} from '../../../state/appState';
import {Observable} from 'rxjs';
import {PaginatedResponseModel} from '../../../shared/models/paginated.response.model';
import {UserModel} from '../../../shared/services/user/user.model';
import {take, tap} from 'rxjs/operators';
import {Debounce} from 'lodash-decorators';
import {
  OpenModalAccountSettings,
  OpenModalUserCreate,
  OpenModalUserDelete,
  OpenModalUserEdit
} from '../../../state/actions/appState.modals.actions';
import {GetUsers} from '../../../state/actions/appState.users.actions';
import {ActivatedRoute} from '@angular/router';

@Component({
  selector: 'app-user',
  templateUrl: './user.component.html',
  styleUrls: ['./user.component.scss']
})
export class UserComponent implements OnInit {
  @Select(AppState.users$) users$: Observable<PaginatedResponseModel<UserModel>>;
  @Select(AppState.currentUser$) currentUser$: Observable<UserModel>;

  private userNameFilter = '';

  constructor(
    private store: Store
  ) {
  }

  ngOnInit(): void {
    this.store.dispatch(new GetUsers());
  }

  onCreateUser() {
    this.store.dispatch(new OpenModalUserCreate());
  }

  onDeleteUser(userName: string) {
    this.store.dispatch(new OpenModalUserDelete(userName));
  }

  onEditUser(user: UserModel) {
    this.currentUser$.pipe(
      take(1),
      tap(current => {
        if (current.userName === user.userName) {
          this.store.dispatch(new OpenModalAccountSettings());
        } else {
          this.store.dispatch(new OpenModalUserEdit(user));
        }
      })
    ).subscribe();
  }

  onPageSelected(page: number) {
    this.users$.pipe(
      take(1),
      tap(users => {
        this.getUsers(page, users.size, this.userNameFilter);
      })
    ).subscribe();
  }

  onSizeSelected(size: number) {
    this.users$.pipe(
      take(1),
      tap(users => {
        this.getUsers(users.number, size, this.userNameFilter);
      })
    ).subscribe();
  }

  @Debounce(1000)
  onFilterChange(username: string) {
    this.userNameFilter = username;
    this.users$.pipe(
      take(1),
      tap(users => {
        this.getUsers(users.number, users.size, this.userNameFilter);
      })
    ).subscribe();
  }

  private getUsers(page: number, size: number, userName: string) {
    this.store.dispatch(new GetUsers(page, size, userName));
  }
}
